import tocbot from "tocbot";

export function initTocbot() {
    tocbot.init({
        tocSelector: '.toc',
        contentSelector: '.gh-content',
        ignoreSelector: '.js-toc-ignore, .gh-post-upgrade-cta h2',
        headingSelector: 'h1, h2',
        hasInnerContainers: true
    });
}
